import { createI18n } from 'vue-i18n'
import en_locales from '@/locales/en.json'

const messages = {
  'en-US': en_locales
}

export const i18n = createI18n({
  legacy: false,
  locale: 'en-US',
  fallbackLocale: 'en-US',
  messages
})
